<template>
  <div class="pa-4">
    <v-card-actions>
      <v-avatar size="40">
        <v-img :src="userFile(academyImage)" />
      </v-avatar>
      <div class="text-subtitle-1 text-truncate ml-2">
        {{ academyName }}
      </div>
      <v-spacer></v-spacer>
      <v-btn icon small color="secondary" @click="closeWindow">
        <XCircleIcon class="hero-button"></XCircleIcon>
      </v-btn>
    </v-card-actions>
    <div style="text-align:center;">
      <h2>{{ documentName }}</h2>
    </div>
    <v-card-text v-if="!waiverContents" class="text-center">
      <v-progress-circular :size="80" color="secondary" indeterminate></v-progress-circular>
    </v-card-text>
    <div v-else v-html="waiverContents" class="text-sm-left pa-2">
    </div>
    <v-card-text v-if="transaction && transaction.product" class="text-left">
      <v-card class="elevation-1">
        <v-card-title>{{ $t('message.document_transaction') }}</v-card-title>
        <v-card-text>
          <h3>{{ transaction.product.name }}</h3>
          <h3 v-if="transaction.product.interval" style="color:gray">
            {{ $t('message.interval_' + transaction.product.interval) }}</h3>
          <h3 style="color:gray">{{ transaction.product.amountDecimal }} {{ transaction.currency }}</h3>
        </v-card-text>
      </v-card>
    </v-card-text>
    <v-card class="waiver">
      <v-card-text v-if="extraFieldValues">
        <template v-for="(field, index) in extraFieldValues">
          <v-text-field disabled :key="'extra_field_' + index" :label="field.fieldName"
            v-model="field.value"></v-text-field>
        </template>
      </v-card-text>
      <v-card-title>
        <v-text-field :label="$t('message.name')" :disabled="true" style="margin-right:20px"
          v-model="participantName"></v-text-field>
        <v-text-field :label="'Email'" :disabled="true" v-model="participantEmail"></v-text-field>
      </v-card-title>
      <v-card-title v-if="documentOwner">
        <v-text-field :disabled="true" style="margin-right:20px" v-model="documentOwner"
          :label="$t('message.on_behalf_of')"></v-text-field>
      </v-card-title>
      <v-card-title>
        <v-text-field :disabled="true" style="margin-right:20px" v-model="guardianName"
          :label="$t('message.guardian')"></v-text-field>
        <v-text-field :disabled="true" v-model="date"></v-text-field>
      </v-card-title>
      <div class="text-center" v-if="signature" style="margin-bottom:15px;">
        <img :src="signature" style="height:150px;border-bottom: 1px solid black" />
        <div style="width:700px;margin-right:auto; margin-left:auto">{{ $t('message.signature') }}</div>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        Powered By
        <img style="width:30px" :src="assets('logo-circle.png')" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Api from '@/services/Api';

import {
  XCircleIcon,
} from '@vue-hero-icons/outline'

export default {
  data() {
    return {
      wid: this.$route.params.wid,
      academyName: null,
      waiverContents: null,
      participantName: null,
      participantEmail: null,
      date: null,
      today: null,
      selectedLang: null,
      signature: null,
      transaction: null,
      documentName: null,
      guardianName: null,
      documentOwner: null,
      academyImage: null,
      extraFieldValues: null
    };
  },
  components: {
    XCircleIcon
  },
  created() {
    Api().get('admins/academy/' + this.$store.state.managedAcademy + '/waiver/' + this.wid)
      .then(response => {
        this.loading = false;
        const data = response.data;
        if (data) {
          this.academyImage = data.image;
          this.academyName = data.academyName;
          this.extraFieldValues = data.waiver.extraFieldValues;
          this.waiverContents = data.waiver.contents ? data.waiver.contents : (data.template.contents ? data.template.contents : data.template.agreement);
          this.participantName = data.waiver.userName;
          this.participantEmail = data.waiver.email;
          this.guardianName = data.waiver.guardianName;
          this.documentOwner = data.waiver.guardianUser ? data.waiver.user.displayName : null;
          this.transaction = data.transaction;
          if (!this.guardianName)
            this.guardianName = ' ';
          this.date = this.toNiceDateCustomFormatAdjusted(data.waiver.time, 'MM/DD/YYYY');
          this.signature = data.waiver.signature;
          if (data.template && data.template.name)
            this.documentName = data.template.name;
        }
      });
  },
  watch: {

  },
  methods: {
    closeWindow() {
      window.close();
    },
    swicthWaiverLang(newLang) {
      if (newLang != this.selectedLang) {
        this.selectedLang = newLang;
        for (const w of this.availableWaivers) {
          if (w.lang == newLang && w.waiver) {
            this.waiverContents = w.waiver;
          }
        }
      }
    }
  }
};
</script>

<style scoped>
.waiver {
  color: black;
  padding-bottom: 5px
}
</style>